<template>
    <div>
      <loadingcomp
        v-bind:mesaj="loadingmesaj"
        v-model="loadingvmodel"
      ></loadingcomp>
      <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
  
      <v-dialog
        persistent
        max-width="700px"
        v-model="dialog"
        @keydown.esc="cancel"
      >
        <v-card>
          <v-card-title style="background-color: #01579b">
            <span class="headline white--text">Coper Firma Parametrelerini Kopyala</span>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-select
                        :items="this.credentials.MuhasebeSirketler"
                        :item-text="item => item.CompanyShortName +' - '+ '(Firma No: ' +  item.CompanyID + ')'"
                        item-value="CompanyID"
                        label="Kaynak Firma"
                        v-model="firmaKopyalaRequest.OldCompanyID"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                      ></v-select> 
                </v-flex>
                
              </v-layout>
              <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <v-select
                        :items="this.credentials.MuhasebeSirketler"
                        :item-text="item => item.CompanyShortName +' - '+ '(Firma No: ' +  item.CompanyID + ')'"
                        item-value="CompanyID"
                        label="Hedef Firma"
                        v-model="firmaKopyalaRequest.NewCompanyID"
                        :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                      ></v-select> 
                </v-flex>
              </v-layout>
          
          
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn :disabled="isAddButtonDisabled" color="primary darken-1" text @click.native="agree">
              {{ 'Kopyala' }}
            </v-btn>
            <v-btn color="grey" text @click.native="cancel">{{
              $t("cancel_button")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <v-dialog persistent max-width="700px" v-model="controlDialog">
        <v-card>
          <v-card-title class="error">
            <span class="headline white--text">Uyarı</span>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <blockquote>
                  Coper Firma Parametrelerini Kopyalama İşlemi Yapılacaktır ?
                </blockquote>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn  :disabled="isAddButtonDisabled" color="primary darken-1" text @click.native="makeChange()">
              {{ 'Kopyala' }}
            </v-btn>
            <v-btn color="grey" text @click.native="controlDialog = false">{{
              $t("cancel_button")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import tarihcomp from "@/components/app/customcomp/tarihim";
  import auth from "../../../../../api/auth";
  import loadingcomp from "@/components/app/customcomp/loadingcomp";
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  
  export default {
    data() {
      return {
        credentials: JSON.parse(window.localStorage.getItem("credentials")),
        controlDialog: false,
        dialog: false,
        loadingvmodel: false,
        text1: null,
        snackbar: false,
        loadingmesaj: "Firma Kopyala",
        tumSirketler: false,
        firmaKopyalaRequest: {
          OldCompanyID :null,
          NewCompanyID :null,
          UserID:0
        },
      };
    },
    components: {
      tarihcomp,
      loadingcomp,
      snackbarcomp,
    },
    computed: {
    isAddButtonDisabled() {
      return !(this.firmaKopyalaRequest.OldCompanyID && this.firmaKopyalaRequest.NewCompanyID);  
    },
  },
    methods: {
      makeChange() {
        this.loadingvmodel = true
        
         this.firmaKopyalaRequest.UserID=this.credentials.UserID;
          var Params = this.firmaKopyalaRequest
          this.$http.post(auth.API_URL + 'api/AccountingParameters/CoperFirmParamsCopy', Params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
  
          
  
            this.loadingvmodel = false
            this.text1 =  response.body.ResponseMessage;
            this.snackbar =true;
  
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Hata-' + response.body.ResponseMessage;
              this.snackbar =true;
              this.loadingvmodel = false
            } else {
              this.text1 = 'Service- FirmCopy';
              this.snackbar =true;
              this.loadingvmodel = false
            }
          })
        
         
          this.controlDialog = false;
          this.dialog=false;
      },
      open() {
        this.dialog = true;
      },
      agree() {
        this.controlDialog = true;
      },
      cancel() {
        this.dialog = false;
      },
    },
  };
  </script>
  
  <style>
  </style>
  